// import { fetch } from "whatwg-fetch";
import Navigation from "../js/Navigation.js";
import InfiniteGallery from "./InfiniteGallery.js";
export default class Gallery {
  constructor(scope) {
    try {
      this.scope = scope;
      this.mainWrapper = document.getElementById("gallery");
      if (this.mainWrapper.classList.contains("hide")) {
        this.mainWrapper.classList.remove("hide");
      }
      this.gallery = document.getElementById("right");
      if (!this.navigation) {
        this.navigation = new Navigation(this);
      }
      this.updateGallery();
    } catch (error) {
      /**silent fail */
    }
  }

  show() {
    if (this.mainWrapper.classList.contains("hide")) {
      this.mainWrapper.classList.remove("hide");
    }
    this.updateGallery();
  }

  updateGallery() {
    this.wrapper = document.createElement("div");
    this.wrapper.id = "wrapper_gallery";
    this.subtitle = document.createElement("div");
    const span = document.createElement("span");
    console.log("modificat");
    span.textContent = this.scope.translator
      ? this.scope.translator.get("subtitle")[this.scope.customGallery]
        ? this.scope.translator.get("subtitle")[this.scope.customGallery]
        : this.scope.translator.get("subtitle")["default"]
        ? this.scope.translator.get("subtitle")["default"]
        : this.scope.translator.get("subtitle")
      : "Invite friends to solve puzzles together. Choose from hundreds of artworks to play.";
    this.subtitle.className = "subtitle";
    this.subtitle.appendChild(span);
    this.wrapper.appendChild(this.subtitle);
    this.gallery.appendChild(this.wrapper);
    this.width = this.wrapper.getBoundingClientRect().width;
    this.height = this.wrapper.getBoundingClientRect().height;
    /**
     *  URL TO BE UPDATED FOR ARTWORKS MODIFICATIONS OR TRANSLATION
     *  IF THE FILE EXIST IN THE STORAGE,WE CAN RELY TO this.LANG
     *  DEFAULT IS ENGLISH AS CREDIT ARE NOT TRANSLATED
     */
    // this.load(
    //   "https://cilex-puzzle.appspot.com.storage.googleapis.com/selection2.json",
    //   this.dataReady.bind(this)
    // );
    this.dataReady(null);

    // this.load('/static/json/selection2.json', this.dataReady.bind(this));
    this.galleryResolution = this.scope.isMobile ? 16 : 25;
    this.galleryOffset = 0;
  }

  async load(url, callback) {
    await fetch(url)
      .then((data) => data.json())
      .then((json) => {
        callback(json);
      });
  }

  dataReady(_data) {
    const data = this.scope.galleryData;
    this.imageDict = {};
    for (let i = 0; i < data.length; i++) {
      this.imageDict[data[i].id] = {
        id: data[i].id,
        url: data[i].url.replace("http://", "https://"),
        width: data[i].width,
        height: data[i].height,
        title: data[i].title,
        creator: data[i].creator,
        collection: data[i].collection,
      };
    }
    this.inifiniteGallery = new InfiniteGallery(
      this.scope,
      this.wrapper,
      this.imageDict,
      this.galleryResolution
    );
  }

  update() {
    this.inifiniteGallery.update();
  }
}
